import {
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTrigger,
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../components/ui/alert-dialog";
import { useAtom } from "jotai";
import { expensesAtom } from "@/store/global";
import { useLayoutEffect, useNavigate, useRouter, useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";

type DeleteExpenseConfirmationProps = React.ComponentPropsWithoutRef<typeof AlertDialog>;

export const DeleteExpensePage = (props: DeleteExpenseConfirmationProps) => {
  const [, setExpenses] = useAtom(expensesAtom);
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const router = useRouter();
  // ?id=QX-ApNapDw_IbMLSD8121
  const search = router.history.location.search;
  // regex to get the id
  const searchId = search.match(/id=([^&]+)/)?.[1];

  useLayoutEffect(() => {
    if (!searchId) {
      navigate({ to: "/" });
    }
  });

  function onDelete() {
    setExpenses((draft) => {
      const expenseIndex = draft.expenses.findIndex((expense) => expense.id === searchId);

      if (expenseIndex === -1) {
        return draft;
      }

      draft.expenses[expenseIndex].deleted = true;
      draft.expenses[expenseIndex].sync = false;
    });
  }

  useEffect(() => {
    if (!open) {
      setTimeout(() => navigate({ to: "/" }), 300);
    }
  }, [open]);

  return (
    <AlertDialog {...props} open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>Hapus</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Hapus Pengeluaran</AlertDialogTitle>
          <AlertDialogDescription className="px-2">Apakah kamu yakin ingin menghapus pengeluaran ini?</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-attr="delete-expense-confirmation-delete-button"
            onClick={onDelete}
            className="bg-red-500 hover:bg-red-600"
          >
            Hapus
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
